/* eslint-disable */
export default {
  noRecords: 'No se encontraron registros recientes.',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
